import { useState } from 'react';
import questionsList from './questions.json';
import { indexToAlphabet, jumbleWithIndex } from './helpers';
import Space from './Space';

const Quiz = ({ setProgress, setPageState, appendAnswer }) => {
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [question, setQuestion] = useState(questionsList[0].question);
    const [options, setOptions] = useState(jumbleWithIndex(questionsList[0].options));
    const [selectedOption, setSelectedOption] = useState(null);

    const handleOptionClick = (answer) => {
        appendAnswer(answer);
        if (currentQuestionIndex < 9) {
            setSelectedOption(null);
            setProgress((currentQuestionIndex + 1) / questionsList.length);
            setCurrentQuestionIndex(currentQuestionIndex + 1);
            setQuestion(questionsList[currentQuestionIndex + 1].question);
            const jumbled = jumbleWithIndex(questionsList[currentQuestionIndex + 1].options);
            setOptions(jumbled);
        } else {
            setProgress(1);
            setPageState('results');
        }
    };

    return (
        <div className="content nopadding">
            <div className="question-container">
                <Space s={40} />
                <div className="question-count">
                    <h1>{String(currentQuestionIndex + 1).padStart(2, '0')}</h1>
                </div>

                <h1 className="question">{question}</h1>
            </div>
            <div className="options-container">
                {options.map((option, index) => (
                    <div
                        key={index}
                        className={selectedOption === index ? 'option with-shadow' : 'option'}
                        onClick={() => setSelectedOption(index)}
                        onAnimationEnd={(e) => handleOptionClick(option.originalIndex)}
                    >
                        <div className="option-button">
                            <h1>{indexToAlphabet(index)}</h1>
                        </div>
                        <div className="option-text">{option.text}</div>
                    </div>
                ))}
            </div>
            <Space s={80} />
        </div>
    );
};

export default Quiz;
